import React, {Component} from 'react';
import { connect } from 'dva';
import { Button, Drawer, Input, Select } from 'antd';
import Dimio, {DimioComponent} from 'dimio';
import ListPage from '../../travel/components/ListPage';
import SearchByCity from './SearchByCity';
import _ from 'lodash';

import config from '../../travel/config/config';
import "../style/search.scss";
import "../../travel/style/travel.scss";
const {travel} = config;
const {Option} = Select;

class SearchKeyword extends DimioComponent {
  constructor(props) {
    super(props);

    this.state = {
      showPanel: false
    };

    this.onSearch = this.onSearch.bind(this);
    this.onOpenPanel  = this.onOpenPanel.bind(this);
    this.onClosePanel = this.onClosePanel.bind(this);
    this.onSelect = this.onSelect.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    const {dispatch } = this.props;

    Dimio.load(travel.api.travelInfo, {
    }).then(res => {
      dispatch({
        type: 'core/initMeta',
        data: res.data
      });
    }).catch(err => {
      console.error(err);
    });
  }

  onChange(e){
    const {dispatch } = this.props;

    dispatch({
      type: 'search/setKeyword',
      keyword:e.currentTarget.value
    });
  }

  onSearch(q){
    const {dispatch} = this.props;
    this.showLoading();
    const self = this;
    q = q.replace(/　/g, ' ');
    console.info(q);

    Dimio.load(travel.api.travelSearch, {
      q:q
    }).then(res => {
      dispatch({
        type: 'search/setItems',
        items: res.data,
        keyword: q
      });

      dispatch({
        type: 'core/setMeta',
        key: 'cities',
        value: res.meta.cities
      });

      this.setState({showPanel: true});
      self.hideLoading();
    }).catch(err => {
      console.error(err);
      self.hideLoading();
    })
  }

  onOpenPanel(){
    this.setState({showPanel: true});
  }

  onClosePanel(){
    this.setState({showPanel: false});
  }

  onSelect(e, opt){
    console.info(opt);
    e.preventDefault();

    this.onSearch(opt.name);
  }

  render() {
    const {core:{ defaultValues, meta }, search: {items, searchKeyword}} = this.props;
    const { showPanel } = this.state;

    {/*
    const cityList = (
      <Select style={{width:'28%'}} defaultValue='default'>
        <Option key='default' value='default'>都市から探す</Option>
        {_.has(meta,'suggestions') &&
        meta.suggestions.map(opt => (
          <Option key={opt.key} value={opt.name}>{opt.name} <span>({opt.cnt})</span></Option>
        ))
        }
      </Select>
    );
    */}
/*
    const addon=(
      <SearchByCity
        items={meta.suggestions}
        onClick={this.onSelect}
      />
    )
*/
    return(
      <section>
        {_.has(meta, 'suggestions') &&
        <Input.Search
          placeholder="検索"
          addonBefore={<SearchByCity
            items={meta.suggestions}
            onClick={this.onSelect}
          />}

          value={searchKeyword}
//          defaultValue={searchKeyword?searchKeyword:defaultValues.keyword?defaultValues.keyword:''}
          defaultValue={defaultValues.keyword?defaultValues.keyword:''}
          onSearch={this.onSearch}
          onChange={this.onChange}
          enterButton
        />
        }

        <Drawer
          width='98%'
          placement="right"
          closable={true}
          onClose={this.onClosePanel}
          visible={showPanel}
        >
          <ListPage
            onClose={this.onClosePanel}
            items={items}
            model='search'
          />
        </Drawer>
      </section>
    );
  }
}

export default connect(({ core, search }) => ({
  core, search
}))(SearchKeyword);




// WEBPACK FOOTER //
// ./src/pages/search/components/SearchKeyword.js